<div class="wrapper">
  <div class="wrapper-sliding-left" [ngClass]="{ closed: !isOpen() }">
    <div class="content-sliding-left">
      <ng-content select="[left]"></ng-content>
    </div>
  </div>
  <div class="wrapper-content">
    <header>
      <inf-actions-bar
        [actions]="displayedActions()"
        [config]="config()"
        (actionClick)="onActionClickToolbar($event)"
      />
    </header>
    <ng-content select="[content]"></ng-content>
  </div>
</div>
